import React from "react";
import { useLocation } from "react-router-dom";
import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";
import { imagePath } from "../../../../config/DataService";

const ImageView = () => {
  const { state } = useLocation();
  const navigate = PagesIndex.useNavigate();

  if (!state?.blobUrl) {
    return (
      <Index.Box className="image-view-container">
        <p style={{ color: "#fff" }}>No Document Found</p>
      </Index.Box>
    );
  }

  const handleBack = () => {
    if (state?.ComponentData === "editsahay") {
      navigate("/user/user-listing-edit", {
        state: state?.state,
      });
    } else if (state?.ComponentData === "adminAddEditSahay") {
      navigate("/user/user-listing-view", {
        state: state?.state,
      });
    } else
      navigate("/user/user-listing-view", {
        state: state?.state,
      });
  };

  // const renderDocument = (url,filename) => {
  //   let extension = "";

  //   if (filename) {
  //     extension = filename.split(".").pop().toLowerCase();
  //   }
  //   else if (url && url.startsWith("blob:")) {
  //     extension = ""; // Blob URL cannot detect type without filename
  //   } else if (url) {
  //     extension = url.split(".").pop().toLowerCase();
  //   }

  //   const filePath = `${imagePath}${filename}`;
  //   if (["png", "jpg", "jpeg", "gif", "webp"].includes(extension)) {
  //     return <img src={filePath} alt="Document" className="fullscreen-image" />;
  //   } else if (extension === "pdf") {
  //     return (
  //       <iframe
  //         src={filePath}
  //         title="PDF Document"
  //         className="fullscreen-pdf"
  //         style={{ width: "100%", height: "100%", border: "none" }}
  //       />
  //     );
  //   } else if (["doc", "docx"].includes(extension)) {
  //     return (
  //       <iframe
  //         src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
  //           filePath
  //         )}`}
  //         title="Word Document"
  //         className="fullscreen-doc"
  //         style={{ width: "100%", height: "100%", border: "none" }}
  //       />
  //     );
  //   } else {
  //     return <p style={{ color: "#fff" }}>Unsupported or Unknown file type</p>;
  //   }
  // };
  const renderDocument = (url, filename) => {
    let extension = "";

    if (filename) {
      extension = filename.split(".").pop().toLowerCase();
    } else if (url && url.startsWith("blob:")) {
      extension = ""; // Blob URL cannot detect type without filename
    } else if (url) {
      extension = url.split(".").pop().toLowerCase();
    }
    if (["png", "jpg", "jpeg", "gif", "webp"].includes(extension)) {
      return <img src={url} alt="Document" className="fullscreen-image" />;
    } else if (extension === "pdf") {
      return (
        <iframe
          src={url}
          title="PDF Document"
          className="fullscreen-pdf"
          style={{ width: "100%", height: "100%", border: "none" }}
        />
      );
    } else if (["doc", "docx"].includes(extension)) {
      return (
        <iframe
          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
            url
          )}`}
          title="Word Document"
          className="fullscreen-doc"
          style={{ width: "100%", height: "100%", border: "none" }}
        />
      );
    } else {
      return <p style={{ color: "#fff" }}>Unsupported or Unknown file type</p>;
    }
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = state.blobUrl;
    link.download = state.docImageData || "downloaded-file";
    link.click();
  };

  return (
    <>
      <Index.Box sx={{ marginTop: "15px" }}>
        <Index.Box className="title-header-flex text-end-details">
          <Index.Box className="common-button blue-button flex-start save-btn">
            <Index.Button variant="contained" onClick={handleBack}>
              Back
            </Index.Button>
          </Index.Box>

          <Index.Box className="common-button blue-button flex-start save-btn">
            <Index.Button
              variant="contained"
              color="secondary"
              onClick={handleDownload}
            >
              Download
            </Index.Button>
          </Index.Box>
        </Index.Box>
      </Index.Box>

      <Index.Box className="image-view-container">
        {renderDocument(state.blobUrl, state.docImageData)}
        {/* {renderDocument(state.docImageData)} */}
      </Index.Box>
    </>
  );
};

export default ImageView;
